module.exports = __webpack_public_path__ + "img/tel_3.49a0963d.png";